import {createContext, useContext, useReducer} from 'react';

export type ActionProps = {
  type: string;
  payload: any;
};

type StoreProviderProps = {
  storeReducer: (prevState: any, action: ActionProps) => any;
  initialState: any;
  children?: JSX.Element | JSX.Element[] | undefined;
};

const StoreContext = createContext({});

export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({
  storeReducer,
  initialState,
  children,
}: StoreProviderProps) => {
  const store = useReducer(storeReducer, initialState);

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};
